$("#ContactToBuyForm").submit(function(event) {
  event.preventDefault();

  const $form = $(this),
    url = $form.attr('action');
  
  const sectionId = $('[id^=ProductSection-]').attr('data-section-id');
  const variantId = $("#ProductSelect-" + sectionId).val();
  
  const posting = $.ajax({
    url: url,
    type: 'post',
    contentType: "application/json; charset=utf-8",
    beforeSend: function() {
      $('#ContactToBuySendButton').addClass('btn--loading');
    }, 
    data: JSON.stringify({
      referrer: "savannahs",
      email: $('#ContactToBuyEmail').val(),
      variantId: variantId
    })
  });

  posting.done(function(data) {
    $('.contact-to-buy-header-text').addClass('approved');
    $('.contact-to-buy-text').addClass('approved');
    $('#ContactToBuyForm').addClass('hidden');
    $('#ContactToBuySendButton').removeClass('btn--loading');
    $('.modal__footer-text').addClass('hidden');
});
  posting.fail(function() {
    $('.contact-to-buy-header-text').addClass('error');
    $('.contact-to-buy-text').addClass('error');
    $('#ContactToBuyForm').addClass('hidden');
	$('#ContactToBuySendButton').removeClass('btn--loading');
    $('.modal__footer-text').addClass('hidden');
});
});